module.exports = __webpack_public_path__ + "static/media/cloud.4975a8fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/equinixIcon/cloud.svg
// module id = 1104
// module chunks = 49